export { default } from './TimelineSeparator';

export { default as timelineSeparatorClasses } from './timelineSeparatorClasses';
export * from './timelineSeparatorClasses';
